// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"jgp-33vxp","logoImage":"jgp-2DwJh"};